export class Menus {
    areaName: string;
    areaPages: Pages[];
}

export class Pages {
    pageName: string;
    routeURL: string;
    permission: {}
}